"use client";
import React from "react";
import { SDialogFC, SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import {showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import { Button, FontIcon } from "@/app/_components";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {ShopItemsListResponse} from "@/app/_api/types/store";
import {openPaymentAsync} from "@/app/(pages)/paymentItemsAPI";
import styles from "./specialGiftPack.module.css";

interface SpecialGiftPackDialogProps extends SDialogProps {
    shopItemsSpecialData: ShopItemsListResponse;
    userId: number;
    dispatcher: any;
}

export const SpecialGiftPackDialogFC: React.FC<SpecialGiftPackDialogProps> = (props) => {
    const { fcKey, shopItemsSpecialData, onClose, userId, dispatcher } = props;
    // console.log(shopItemsSpecialData);

    // 随机选择一个礼包
    // const randomIndex = Math.floor(Math.random() * shopItemsSpecialData.length);
    const randomGift = shopItemsSpecialData[0];


    const handleSpecialGiftPackClick = () => {
        showForceLoading();
        const params = {
            userId,
            ...randomGift,
        }
        // 调起支付
        dispatcher(openPaymentAsync(params));
    }

    const handleClose = () => {
        onClose?.();
        SDialogManagerFC.closeDialog(fcKey);
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Full"
            onClose={onClose}
        >

            <section className={`${styles.wrapper} h-v-center`}>
                <div className={`${styles.icon_close} btn center`} onClick={handleClose}>
                    <FontIcon icon="s-close" style={{color: "#fff"}}/>
                </div>
                <section className={styles.content}>
                    <div className={styles.vipExp_box}>
                        <img style={{width: "0.65rem", verticalAlign: "text-top", marginRight: ".1rem"}}
                             src="/img/img_vip.webp" alt=""/>
                        <span>VIP +{randomGift.vipExperience}</span>
                    </div>
                    <h4>SPECIAL OFFER</h4>
                    <div className={styles.main}>
                        <div className={styles.large_star}></div>
                        <div className={styles.small_star}></div>
                        <div className={styles.more_value}>
                            <div className={styles.strong_text}>100%</div>
                            <div className={styles.small_text}>
                                <p>MORE</p>
                                <p>VALUE</p>
                            </div>
                        </div>
                        <img
                            className={styles.main_icon}
                            src="/img/ico_gift_special.webp"
                            alt="Special Gift"
                        />
                        <div style={{marginBottom: ".1rem"}}>
                            <img
                                style={{
                                    verticalAlign: "-0.1rem",
                                }}
                                className={styles.icon_gold}
                                src="/img/ico_gc.png"
                                alt="Gold Coin"
                            />
                            <span
                                className={styles.text_num}
                                style={{
                                    fontSize: ".8rem",
                                    color: "#FAEE31",
                                }}
                            >
                                GC {randomGift.gc.toLocaleString()}
                            </span>
                        </div>
                        <div className={styles.text_plus}>+</div>
                        <div>
                            <img
                                style={{
                                    verticalAlign: "-0.1rem",
                                }}
                                className={styles.icon_gold}
                                src="/img/ico_sc.png"
                                alt="Special Coin"
                            />
                            {/*<span className={styles.text_num}>SC {randomGift.sc}</span>*/}
                            {randomGift.extraScLimit === 0 ?
                                <span className={styles.text_num}>SC {randomGift.sc}</span>
                                :
                                <span
                                    className={styles.text_num}>SC {randomGift.sc}-SC {randomGift.sc + randomGift.extraScLimit}</span>
                            }
                        </div>
                    </div>
                    <Button
                        color="#33D24A"
                        cls={'btn'}
                        style={{
                            color: "#fff",
                            width: "5rem",
                            height: "1.1rem",
                            fontSize: ".5rem",
                            fontWeight: 900,
                        }}
                        onClick={handleSpecialGiftPackClick}
                    >
                        Buy for ${randomGift.money}
                    </Button>
                </section>
                <section className={styles.tips}>
                    <span className={styles.star}>*</span>
                    <span>SC are Free Benefits, comes with the GC purchase.</span>
                </section>
            </section>
        </SDialogFC>
    );
};
